function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import { withNativeProps } from "../../utils/with-native-props";
import cx from "classnames";
var classPrefix = "tc-im-brand-item";
var BrandItem = function BrandItem(props) {
  var src = props.src,
    name = props.name,
    desc = props.desc,
    onClick = props.onClick,
    rightContent = props.rightContent;
  var baseProps = {
    onClick: onClick,
    className: cx(classPrefix, _defineProperty({}, "".concat(classPrefix, "-right-content"), !!rightContent))
  };
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-image-item")
  }, /*#__PURE__*/React.createElement("img", {
    className: "".concat(classPrefix, "-image"),
    src: src
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-message")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-name")
  }, name), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-desc")
  }, desc)), !!rightContent && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-right")
  }, rightContent)));
};
BrandItem.defaultProps = {};
export default BrandItem;